import actionTypes from './actionTypes';

export const retrieveInventorySchemas = data => ({
  type: actionTypes.REQUEST_INVENTORY_SCHEMAS,
  data,
});

export const getInventorySchemasSuccess = data => ({
  type: actionTypes.GET_INVENTORY_SCHEMAS_SUCCESS,
  data,
});

export const getInventorySchemasFailure = () => ({
  type: actionTypes.GET_INVENTORY_SCHEMAS_FAILURE,
});

export const retrieveInventorySchema = data => ({
  type: actionTypes.REQUEST_INVENTORY_SCHEMA,
  data,
});

export const getInventorySchemaSuccess = data => ({
  type: actionTypes.GET_INVENTORY_SCHEMA_SUCCESS,
  data,
});

export const getInventorySchemaFailure = () => ({
  type: actionTypes.GET_INVENTORY_SCHEMA_FAILURE,
});

export const retrieveInventorySchemaByAssetId = data => ({
  type: actionTypes.REQUEST_INVENTORY_SCHEMA_BY_ASSET_ID,
  data,
});

export const requestInventorySchemaClear = () => ({
  type: actionTypes.REQUEST_INVENTORY_SCHEMA_CLEAR,
});

export const clearInventorySchemaSuccess = () => ({
  type: actionTypes.CLEAR_INVENTORY_SCHEMA_SUCCESS,
});

export const retrieveInventorySchemaTreeNode = data => ({
  type: actionTypes.REQUEST_INVENTORY_SCHEMA_TREE_NODE,
  data,
});

export const getInventorySchemaTreeNodeSuccess = data => ({
  type: actionTypes.GET_INVENTORY_SCHEMA_TREE_NODE_SUCCESS,
  data,
});

export const getInventorySchemaTreeNodeFailure = () => ({
  type: actionTypes.GET_INVENTORY_SCHEMA_TREE_NODE_FAILURE,
});

export const requestSchemaTree = data => ({
  type: actionTypes.REQUEST_SCHEMA_TREE,
  data,
});

export const getSchemaTreeSuccess = data => ({
  type: actionTypes.GET_SCHEMA_TREE_SUCCESS,
  data,
});

export const getSchemaTreeFailure = () => ({
  type: actionTypes.GET_SCHEMA_TREE_FAILURE,
});

export const retrieveSchemaDetail = data => ({
  type: actionTypes.REQUEST_SCHEMA_DETAIL,
  data,
});

export const getSchemaDetailSuccess = data => ({
  type: actionTypes.GET_SCHEMA_DETAIL_SUCCESS,
  data,
});

export const getSchemaDetailFailure = () => ({
  type: actionTypes.GET_SCHEMA_DETAIL_FAILURE,
});

export const requestSchemaTreeUpdate = data => ({
  type: actionTypes.REQUEST_SCHEMA_TREE_UPDATE,
  data,
});

export const updateSchemaTreeSuccess = data => ({
  type: actionTypes.UPDATE_SCHEMA_TREE_SUCCESS,
  data,
});

export const updateSchemaTreeFailure = () => ({
  type: actionTypes.UPDATE_SCHEMA_TREE_FAILURE,
});

export const requestSchemasByIds = data => ({
  type: actionTypes.REQUEST_SCHEMA_BY_IDS,
  data,
});

export const getSchemasByIdsSuccess = data => ({
  type: actionTypes.GET_SCHEMA_BY_IDS_SUCCESS,
  data,
});

export const getSchemasByIdsFailure = () => ({
  type: actionTypes.GET_SCHEMA_BY_IDS_FAILURE,
});
